import * as fromMemberForm from './member-form.reducer';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'memberForm';

export interface MemberFormState {
  memberForm: fromMemberForm.MemberFormState;
}

export const reducers: ActionReducerMap<MemberFormState> = {
  memberForm: fromMemberForm.MemberFormReducer,
};

export const getMemberFormFormState = createFeatureSelector<MemberFormState>(featureKey);

export const metaReducers: MetaReducer<MemberFormState>[] = !environment.production ? [] : [];
